import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { crearOTSteps, crearProductoSteps, crearServicioSteps, crearVentaSteps, driverBase, sidebarSteps } from 'src/app/utils/tutorial/steps';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { SuscripcionesInformacionPlanesComponent } from 'src/app/components/suscripciones/suscripciones-informacion-planes/suscripciones-informacion-planes.component';
import { SuscripcionesService } from 'src/app/components/suscripciones/suscripciones.service';
import { SentryService } from 'src/app/utils/sentry/sentry.service';
import { SesionService } from 'src/app/utils/sesion/sesion.service';

@Component({
  selector: 'app-trial-to-premium',
  templateUrl: './trial-to-premium.component.html',
  styleUrls: ['./trial-to-premium.component.scss'],
})
export class TrialToPremiumComponent implements OnInit {

  @Input() soloDemo: boolean = true;
  @Input() showTutorialButton: boolean = true;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    public modalService: NgbModal,
    private sesion: SesionService,
    private loading: LoadingService,
    private alerts: AlertService,
    private suscripcionesService: SuscripcionesService,
    private sentryService: SentryService,
  ) { }

  ngOnInit() { }

  guardar() {
    this.activeModal.close(true);
  }

  cancelar() {
    this.activeModal.dismiss();
  }

  email(): void {
    const mailText = "mailto:soporte@kuvemar.com+?subject=files&body=";
    window.location.href = mailText;
    this.activeModal.dismiss();
  }

  whatsApp(): void {
    const whatsApp = "https://api.whatsapp.com/send?phone=56944758039";
    window.location.href = whatsApp;
    this.activeModal.dismiss();
  }

  whatsAppKuvemar(): void {
    const whatsApp = "https://api.whatsapp.com/send?phone=56944758039";
    window.location.href = whatsApp;
    this.activeModal.dismiss();
  }

  tel(): void {
    const tel = "tel:+56944758039";
    window.location.href = tel;
    this.activeModal.dismiss();
  }

  iniciarTutorial(): void {
    this.activeModal.close();

    const driverObj = driverBase;

    // ej: /revisiones/create
    const url = this.router.url;
    // orden del if importa
    if (url.includes('revisiones/create-venta')) {
      driverObj.setSteps(crearVentaSteps(driverObj));
    } else if (url.includes('revisiones/create')) {
      driverObj.setSteps(crearOTSteps(driverObj));
    } else if (url.includes('servicio/index')) {
      driverObj.setSteps(crearServicioSteps(driverObj, this.modalService));
    } else if (url.includes('producto/index')) {
      driverObj.setSteps(crearProductoSteps(driverObj, this.modalService));
    } else {
      driverObj.setSteps(sidebarSteps(driverObj));
    }

    driverObj.drive();
  }

  verTutoriales(): void {
    this.router.navigate(['/ayuda']);
    this.activeModal.dismiss();
  }

  abrirModalSuscripcion(): void {
    if (!this.sesion.enableSubscriptionUI) return;
    this.loading.show();
    this.suscripcionesService.planActual().subscribe({
      next: (res: any) => {
        this.loading.hide();
        const modalRef = this.modalService.open(SuscripcionesInformacionPlanesComponent, { size: 'xl', scrollable: true, centered: true });
        modalRef.componentInstance.suscripcionPrevia = res.suscripcion;
        modalRef.componentInstance.suscripcionVPPrevia = res.suscripcionVP;
        modalRef.componentInstance.suscripcionDLGPrevia = res.suscripcionDLG;
        modalRef.result.then((result: any) => { }, (reason: any) => { });
      },
      error: (err: any) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("Error al obtener la información.", "danger");
        this.sentryService.captureException(err.error);
      }
    });
  }
}
